'use es6';

export const getOffsetTop = el => {
  if (!el) {
    return 0;
  }

  return getOffsetTop(el.offsetParent) + el.offsetTop;
};